// api/ad.js
import request from './request'

function cleanJsonValue(value) {
    if (value === null || value === undefined) {
        return undefined
    }

    if (Array.isArray(value)) {
        return value
            .map(item => cleanJsonValue(item))
            .filter(item => item !== undefined)
    }

    if (typeof value === 'object') {
        return Object.keys(value).reduce((result, key) => {
            const cleanValue = cleanJsonValue(value[key])
            if (cleanValue !== undefined) {
                result[key] = cleanValue
            }
            return result
        }, {})
    }

    return value
}

function sanitizeCreativeList(creativeList) {
    return (creativeList || [])
        .map(creative => {
            const creativeInfo = cleanJsonValue(creative && creative.creative_info)
            if (!creativeInfo || Object.keys(creativeInfo).length === 0) {
                return null
            }
            return { creative_info: creativeInfo }
        })
        .filter(Boolean)
}

export const adApi = {
    // 获取广告列表
    getList(params) {
        return request({
            url: '/ad/list',
            method: 'get',
            withCredentials: false,
            params: {
                advertiserId: params.advertiserId,
                page: params.page || 1,
                pageSize: params.pageSize || 20,
                adName: params.adName || '',
                adgroupId: params.adgroupId || '',
                campaignId: params.campaignId || '',
                adFormat: params.adFormat || '',
                operationStatus: params.operationStatus || '',
                startDate: params.startDate || '',
                endDate: params.endDate || ''
            }
        })
    },

    // 创建广告
    create(data) {
        return request({
            url: '/ad/create',
            method: 'post',
            withCredentials: false,
            data: {
                advertiser_id: data.advertiserId,  // 广告主ID
                adgroup_id: data.adgroup_id,  // 广告组ID
                ad_name: data.ad_name,// 广告名称
                creative_list: sanitizeCreativeList(data.creative_list),// 创意列表
                ad_text_list: data.ad_text_list,// 广告文案列表
                call_to_action_list: data.call_to_action_list,// 行动号召列表
                landing_page_url_list: data.landing_page_url_list,// 落地页URL列表
                operation_status: data.operation_status || 'ENABLE',
                ad_configuration: data.ad_configuration,
                client_batch_id: data.client_batch_id,
                client_batch_index: data.client_batch_index,
                client_batch_total: data.client_batch_total,
                client_batch_concurrency: data.client_batch_concurrency,
                client_adgroup_name: data.adgroup_name
            }
        })
    },

    // 更新广告
    update(data) {
        return request({
            url: '/ad/update',
            method: 'post',
            data: {
                advertiserId: data.advertiserId,
                smartPlusAdId: data.smart_plus_ad_id,
                adName: data.ad_name,
                creativeList: data.creative_list,
                adTextList: data.ad_text_list
            }
        })
    },

    // 更新广告状态
    updateStatus(data) {
        return request({
            url: '/ad/status/update',
            method: 'post',
            withCredentials: false,
            data: {
                advertiser_id: data.advertiser_id,
                smart_plus_ad_ids: data.smart_plus_ad_ids,
                operation_status: data.operation_status
            }
        })
    },

    // 预览广告
    preview(advertiserId, smartPlusAdId) {
        return request({
            url: '/ad/preview',
            method: 'post',
            withCredentials: false,
            data: {
                advertiserId,
                smartPlusAdId
            }
        })
    },

    // 获取审核信息
    getReviewInfo(params) {
        return request({
            url: '/ad/review/info',
            method: 'get',
            withCredentials: false,
            params: {
                advertiserId: params.advertiserId,
                smartPlusAdId: params.smartPlusAdId,
                includeRejectInfo: params.includeRejectInfo || true
            }
        })
    },

    getMaterialReviewInfo(data) {
        return request({
            url: '/api/smart-plus/material/review-info',
            method: 'post',
            withCredentials: false,
            data: {
                advertiserId: data.advertiserId,
                adMaterialIds: data.adMaterialIds || [],
                videoRecordIds: data.videoRecordIds || [],
                materialIds: data.materialIds || [],
                videoIds: data.videoIds || [],
                includeRejectInfo: data.includeRejectInfo !== false
            }
        })
    },

    // 申诉
    appeal(data) {
        return request({
            url: '/ad/appeal',
            method: 'post',
            data: {
                advertiserId: data.advertiserId,
                smartPlusAdId: data.smart_plus_ad_id,
                appealReason: data.appeal_reason,
                attachmentList: data.attachment_list
            }
        })
    }
}

export const ctaApi = {
    getRecommendCta(params) {
        return request({
            url: '/app/cta/recommend',
            method: 'get',
            withCredentials: false,
            params: {
                advertiserId: params.advertiserId,
                objectiveType: params.objectiveType || 'APP_PROMOTION',
                promotionType: params.promotionType || 'MINI_GAME',
                language: params.language || 'en'
            }
        })
    },

    createPortfolio(data) {
        return request({
            url: '/app/portfolio/create',
            method: 'post',
            withCredentials: false,
            data: {
                advertiser_id: data.advertiserId,
                portfolio_content: data.portfolioContent
            }
        })
    }
}
export const imageApi = {
    uploadByUrl(data) {
        return request({
            url: '/image/upload/url',
            method: 'post',
            withCredentials: false,
            data: {
                advertiserId: data.advertiserId,
                imageUrl: data.imageUrl,
                fileName: data.fileName || 'tiktok_image.jpg'
            }
        })
    }
}
export const videoApi = {
    uploadByFile(formData) {
        return request({
            url: '/video/upload/file/async',
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: false,
            data: formData
        })
    },

    uploadByUrl(data) {
        return request({
            url: '/video/upload/url',
            method: 'post',
            withCredentials: false,
            data: {
                advertiserId: data.advertiserId,
                videoUrl: data.videoUrl,
                fileName: data.fileName,
                videoSignature: data.videoSignature,
                isThirdParty: data.isThirdParty,
                flawDetect: data.flawDetect,
                autoFixEnabled: data.autoFixEnabled,
                autoBindEnabled: data.autoBindEnabled
            }
        })
    },

    search(params) {
        return request({
            url: '/tiktok/videos/search',
            method: 'get',
            withCredentials: false,
            params: {
                advertiserId: params.advertiserId,
                videoName: params.videoName,
                page: params.page || 1,
                pageSize: params.pageSize || 20
            }
        })
    },

    deleteByMaterials(data) {
        return request({
            url: '/api/tiktok/video/v2/records/delete-by-materials',
            method: 'post',
            withCredentials: false,
            data: {
                materialIds: data.materialIds || [],
                videoIds: data.videoIds || [],
                deletedBy: data.deletedBy || '',
                reason: data.reason || ''
            }
        })
    }
}
